var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResolvido2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Resolvido_2",
    "data-name": "Resolvido 2",
    transform: "translate(-596 -521)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1775",
    "data-name": "Ret\\xE2ngulo 1775",
    width: 50,
    height: 50,
    transform: "translate(596 521)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M11.387,29.086l-10.9-10.9a1.676,1.676,0,0,1,0-2.371l2.371-2.371a1.676,1.676,0,0,1,2.371,0l7.34,7.34L28.293,5.068a1.676,1.676,0,0,1,2.371,0l2.371,2.371a1.676,1.676,0,0,1,0,2.371L13.757,29.086A1.676,1.676,0,0,1,11.387,29.086Z",
    transform: "translate(604.238 528.923)",
    fill: "#048243"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResolvido2);
export default __webpack_public_path__ + "static/media/Resolvido 2.8da56047a6b7516ab565eaa07dbd60fd.svg";
export { ForwardRef as ReactComponent };